import React, { SyntheticEvent } from "react";
import TextField from "@mui/material/TextField";
import Autocomplete from "@mui/material/Autocomplete";
import { ExtendPerson, PersonExtended } from "../../../Utils/TypeExtensions";
import { IntegerCustomControlProps } from "../../../Utils/Interfaces";
import { ObjectUtils } from "../../../Utils/ObjectUtils";
import { useLiveQuery } from "dexie-react-hooks";
import { TicketDatabase } from "../../../Utils/TicketDatabase";
import { CONTROL_MARGIN } from "../../../MuiThemes";
import { getHelperText, propertyHasErrors } from "../inputHelpers";

export default function PilotSelector(props: IntegerCustomControlProps): JSX.Element {
    const pilotList = useLiveQuery(async () => TicketDatabase.pilot.toArray());

    if (!pilotList) return <></>;

    function handleOnChange(e: SyntheticEvent, value: string | PersonExtended | null) {
        let newId;
        if (value !== null) {
            newId = (value as PersonExtended).id;
        }

        props.mergeChanges(props.sourceId, { [props.sourceProperty]: newId });
    }

    const pilotListToPresent: PersonExtended[] = ObjectUtils.convertToUppercase(pilotList.map((pilot) => ExtendPerson(pilot)));

    const sortedNames = pilotListToPresent.sort((a: PersonExtended, b: PersonExtended) => {
        return (a.selectName ?? "").localeCompare(b.selectName ?? "");
    });

    const initialValue = pilotListToPresent.find((p) => p.id === props.initialValue);

    return (
        <>
            <Autocomplete
                value={initialValue === undefined ? null : initialValue}
                disabled={props.isDisabled}
                options={sortedNames}
                onChange={handleOnChange}
                getOptionLabel={(option: PersonExtended) => option.selectName ?? ""}
                filterSelectedOptions
                renderInput={(params) => (
                    <TextField
                        required={props.isRequired}
                        error={propertyHasErrors(props.errors, props.containerUrl, props.sourceId, props.sourceProperty)}
                        helperText={getHelperText(props.errors, props.containerUrl, props.sourceId, props.sourceProperty)}
                        {...params}
                        margin={CONTROL_MARGIN}
                        label={props.labelText}
                        placeholder="type to search"
                    />
                )}
            />
        </>
    );
}
